import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined, HomeOutlined } from '@ant-design/icons';
import '../../styles/components/page.scss';

interface Props {
	title: string;
	children: React.ReactNode;
	actions?: React.ReactNode;
	bottomTitle?: string;
	number?: string | number;
	footer?: React.ReactNode;
}

const Page: React.FC<Props> = ({ title, children, actions, bottomTitle, number, footer }) => {
	const navigate = useNavigate();

	return (
		<div className="wrapper">
			<div className="page flex flex-dir">
				<div className="header flex flex-ac">
					<div className="back flex flex-jc flex-ac" onClick={() => navigate(-1)}>
						<ArrowLeftOutlined />
					</div>
					<h1>{title}</h1>
					<div className="home flex flex-jc flex-ac" onClick={() => navigate('/panel')}>
						<HomeOutlined />
					</div>
				</div>
				<div className="content flex flex-dir">
					{children}
					{(actions || bottomTitle || number || footer) && (
						<div className="footer flex flex-jsb flex-jc">
							{footer ?? (
								<>
									<div>{actions}</div>
									{(bottomTitle || number) && (
										<div>
											<span>{bottomTitle}</span>
											<span>{number}</span>
										</div>
									)}
								</>
							)}
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default Page;
